import styled from 'styled-components';
import Arrow from '@/assets/images/icon-arrow.svg?react';

interface CardBodyProps {
  $isCompleted?: boolean;
  $isSelected?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0.108rem rgba(0, 0, 0, 0.25);
  border-radius: 0.379rem;
  margin-top: 1.75rem;
  padding: 1rem 0.625rem;
  gap: 1.125rem;
  position: relative;
  background-color: #fff;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #fff;

  h1 {
    font-weight: 600;
  }
`;

export const SubTitle = styled.h1`
  font-weight: 600;
  padding: 0;
  margin: 0;
  text-align: start;
`;

export const Label = styled.p`
  color: #273141;
  font-size: 0.812rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: start;
`;

export const CardBody = styled.div<CardBodyProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${({ $isCompleted }) => ($isCompleted ? '11.375rem' : '34.538rem')};
  height: ${({ $isCompleted }) => ($isCompleted ? '7.625rem' : 'auto')};
  padding: ${({ $isCompleted }) => ($isCompleted ? '0.596rem 0.596rem 0.596rem 1.299rem' : '0.596rem 7.362rem 0.596rem 1.299rem')};
  gap: 0.379rem;
  border-radius: 0.162rem;
  background: var(--BG-Primary, #f9f9fa);
  cursor: pointer;
  border: ${({ $isSelected, theme }) => ($isSelected ? `2px solid ${theme.colors.primary}` : 'none')};
  box-shadow: ${({ $isSelected }) => ($isSelected ? '0 0 10px rgba(81, 64, 233, 0.3)' : '0 0 0.108rem rgba(0, 0, 0, 0.25)')};
  background-color: #f5f5f5;
  margin: 10px 0;
`;

export const Address = styled.p`
  color: #000;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.02rem;
  text-align: start;
  margin: 0;
`;

export const Info = styled.p`
  color: #273141;
  font-size: 0.704rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: start;
  margin: 0;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;

  > button:hover {
    opacity: 0.7;
  }
`;

export const ArrowIcon = styled(Arrow)`
  width: 2.2rem;
  height: 1.5rem;
  flex-shrink: 0;
  padding-left: 1rem;
  fill: #000;
`;

export const ButtonStyles = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  background: #fff;
  padding: 0.375rem 0.813rem;
  color: #273141;
  font-size: 0.758rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.008rem;
  border-radius: 0.108rem;
  border: 0.054rem solid #5140e9;
  box-shadow: 0 0.217rem 0.217rem rgba(0, 0, 0, 0.08);
  transition: opacity 0.2s ease;
  cursor: pointer;
  opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0.6)};
  pointer-events: ${({ $isSelected }) => ($isSelected ? 'auto' : 'none')};
  &:hover {
    opacity: 0.8;
  }
`;

export const ButtonReStartApp = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.75rem;

  button {
    background: transparent;
    border: none;
    color: ${(props) => props.theme.colors.primary};
    font-size: 0.813rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Badge = styled.div`
  display: flex;
  padding: 0.109rem 0.434rem;
  align-items: flex-start;
  background: ${(props) => props.theme.colors.primary};
  color: #fff;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Poppins;
  font-size: 0.814rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.086rem;
  width: 7rem;
  height: 1.1rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.635rem;
`;
